// extracted by mini-css-extract-plugin
export default {"modal-alert":"ConfigFormSetupIsaAnaliseDeCobertura_modal-alert__+UEI0"};